import { Common, ApiBind } from './common.model';

export class DeliverySetDeal extends Common {
  @ApiBind({ column: 'deal_id' })
  dealId: number;
}
